export enum MdEnableStatusEnum {
    DISABLE,
    ENABLE
}

export enum PartnerTypeEnum {
    CUSTOMER = "PARTNER-TYPE.CUS",
    SUPPLIER = "PARTNER-TYPE.SUP"
}
export enum UserTypeEnum {
    EMPLOYEE = "user-type.employee", // "内部员工"
    MICRO_BOSS = "user-type.micro-boss", // "微老板"
    DRIVER = "user-type.driver", //"司机"
    HEADMAN = "user-type.headman", //"队长"
    BOSS = "user-type.boss", // "老板"
    SUPPLIER = "user-type.supplier", //"供应商"
    CUSTOMER = "user-type.customer", //"客户"
}
export enum TradeTypeEnum {
    PURCHASE_ORDER = "TRADE-TYPE.PURCHASE-ORDER",
    PURCHASE = "TRADE-TYPE.PURCHASE",
    PURCHASE_RETURN = "TRADE-TYPE.PURCHASE-RETURN",
    SALE_ORDER = "TRADE-TYPE.SALE-ORDER",
    SALE = "TRADE-TYPE.SALE",
    SALE_RETURN = "TRADE-TYPE.SALE-RETURN",
    REPAIR_YX = "TRADE-TYPE.YX-REPAIR",
    REPAIR_YC = "TRADE-TYPE.YC-REPAIR",
    LOSS = "TRADE-TYPE.LOSS",
    REDUCTION = "TRADE-TYPE.REDUCTION",
}

export enum ReviewStatusEnum {
    INIT,
    REVIEWING,
    REVIEWED,
    REJECTED = 9,
}

export enum AccountStatusEnum {
    INIT,
    DISABLED = 9
}

export enum CreditFlagEnum {
    NON_CREDIT,
    CREDIT
}

export enum AdjustStatusEnum {
    INIT,
    REVIEWING,
    ADJUSTED,
    REJECTED = 8,
    FAIL,
}

export enum RechargeStatusEnum {
    INIT,
    RECHARGED,
    FAIL = 9,
}

export enum TransferStatusEnum {
    INIT,
    RECHARGED,
    FAIL = 9
}

export enum AccountLogTypeEnum {
    OPEN = "OPEN",
    DISABLE = "DISABLE",
    ENABLE = "ENABLE",
    ADJUST = "ADJUST",
    ADJUST_APPROVAL = "ADJUST_APPROVAL",
    RECHARGE = "RECHARGE",
    TRANSFER_IN = "TRANSFER_IN",
    TRANSFER_OUT = "TRANSFER_OUT",
    BALANCE = "BALANCE",
    UPDATE = "UPDATE",
}

export enum BillIoFlagEnum {
    IN = 1,
    OUT
}

export enum BillPayTypeEnum {
    CASH = 1,
    CREDIT_ACCOUNT
}

export enum BillStatusEnum {
    INIT,
    BOOKED,
    BALANCED
}

export enum BillCashStatusEnum {
    INIT,
    CASHED,
    RECHARGED,
    BALANCED,
    FAIL = 9,
}

export enum BillCancelStatusEnum {
    INIT,
    REVIEWING,
    CANCELLED,
    FAIL,
}

export enum BillInvoiceStatusEnum {
    INIT,
    APPLYING,
    PARTIAL,
    INVOICED,
}

export enum BillBalanceStatusEnum {
    INIT,
    BALANCED,
    FAIL = 9,
}

export enum BillLogTypeEnum {
    INSERT = "INSERT",
    APPROVAL = "DISABLE",
    CREDIT_BOOK = "CREDIT_BOOK",
    CASH_BOOK = "CASH_BOOK",
    BALANCE = "BALANCE",
    INVOICE = "INVOICE",
    INVOICE_CANCEL = "INVOICE",
    INVOICE_APPROVAL = "INVOICE_APPROVAL",
    CANCEL = "CANCEL",
    CANCEL_APPROVAL = "CANCEL_APPROVAL",
}
export enum DetailType {
    "add" = "add",
    "edit" = "edit",
    "look" = "look"
}
// const titleType = {
//     add: "新增",
//     edit: "编辑",
//     look: "查看",
// }
export enum titleType {
    add = "新增",
    edit = "编辑",
    look = "查看",
}